module.exports = __webpack_public_path__ + "static/media/investmentCharge.f5694bb6.svg";